import { flagSrc } from '@/components/einvoicing/einvoicingFlags';
// Round flag for an e-Invoicing country (code = two-letter country code, e.g. "PL").
const EinvoicingFlag = ({ code, name = '', className = 'h-10 w-10' }) => {
  const src = flagSrc(code);
  if (!src) return null;
  return (
    <img
      src={src}
      alt={name ? `Flag of ${name}` : ''}
      className={`${className} rounded-full ring-1 ring-slate-200 shadow-sm shrink-0`}
      loading="lazy"
      draggable={false}
    />
  );
};
export default EinvoicingFlag;
